[
  { "code": "en", "name": "English", "dir": "ltr" },
  { "code": "zh-CN", "name": "简体中文", "dir": "ltr" },
  { "code": "zh-TW", "name": "繁體中文", "dir": "ltr" },
  { "code": "es", "name": "Español", "dir": "ltr" },
  { "code": "fr", "name": "Français", "dir": "ltr" },
  { "code": "de", "name": "Deutsch", "dir": "ltr" },
  { "code": "ru", "name": "Русский", "dir": "ltr" },
  { "code": "he", "name": "עברית", "dir": "rtl" },
  { "code": "ar", "name": "العربية", "dir": "rtl" },
  { "code": "ja", "name": "日本語", "dir": "ltr" },
  { "code": "ko", "name": "한국어", "dir": "ltr" }
]
